import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { EditableInfoComponent, Row } from 'components';
import { ShippingMethodType, ShippingSpeedType } from 'typings/client';
import { SpecialRateIcon } from 'components/common/icons/SpecialRateIcon';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { LeadTime } from './addEdit/useRatesAddEditModal';
import { ShippingRateCard } from './shippingRateCard';
import { useSpecialRates } from './useSpecialRates';
import { RatesAddEditModal } from './addEdit';
import styles from './styles.module.scss';
import { DeleteModal } from './delete';

export interface Price {
  metrics: 'KG' | 'VOLUME';
  measurementRange: string;
  price: string;
}

export interface SupplierSpecialRate {
  id?: string;
  supplierId: string;
  warehouseId: string;
  shippingMethod: ShippingMethodType;
  shippingSpeed: ShippingSpeedType;
  timeUnit: LeadTime;
  warehouse: Record<string, any>;
  leadTimeMax: number;
  leadTimeMin: number;
  prices: Price[];
  specialHandling: '';
}

export const ShippingRates = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    openModal,
    dataToEdit,
    specialRatesData,
    isDeleteModalOpen,
    onHandleEdit,
    onHandleDelete,
    onDeleteModalClose,
    onModalStateChange,
  } = useSpecialRates();
  return (
    <>
      <Row className={styles.shipping_special_rate}>
        <EditableInfoComponent
          title={'Shipping Rates'}
          icon={<SpecialRateIcon />}
          creatable={hasAccess(PERMISSIONS.suppliers.shipping_rate.write)}
          editable={false}
          onAdd={onModalStateChange}
        />
        {specialRatesData.map((i: SupplierSpecialRate) => (
          <ShippingRateCard key={i.id} specialRate={i} onHandleEdit={onHandleEdit} onHandleDelete={onHandleDelete} />
        ))}
      </Row>
      <RatesAddEditModal modalState={openModal} onModalStateChange={onModalStateChange} dataToEdit={dataToEdit} />
      <DeleteModal openModal={isDeleteModalOpen} onDeleteModalClose={onDeleteModalClose} dataToDelete={dataToEdit} />
    </>
  );
});
